<template>

  <!-- 属性模块 -->
  <div class="actioninfo" id="ACTIONINFO-SWF">

    <div class="mask" v-show="mask_visible"></div>

    <div class="option">
      <div class="item"><el-checkbox v-model="finality" @change="handleChangeFinality">全身动作</el-checkbox></div>
      <div class="item"><el-checkbox v-model="looped" @change="handleChangeLooped">循环动作</el-checkbox></div>
    </div>

    <div class="slider">
      <div class="text1" style="color:#e2e2e2;" :class="{active: looped}">{{"移动速度：" + ((looped_value == undefined || looped_value == NaN) ? 0 : (looped_value/100).toFixed(2))}}</div>
      <span class="l">0</span>
      <span class="r">1</span>
      <el-slider style="-webkit-transform:scale(0.55);width:300px;left:-70px;position:relative;" v-model="looped_value" :format-tooltip="formatTooltip" :disabled="!looped" @change="handleChangeSliderOption(looped_value)"></el-slider>
      <div class="text2">0表示不可移动</div>
    </div>

    <div class="tip">
      <span class="l">
        <span>NEXT动作：</span>
        <span>{{next.length > 10 ? next.substring(0, 10) + '...' : next}}</span>
        <span class="el-icon-close" style="width:25px;height:25px;margin-left:5px;margin-top:-2px;" v-show="next != '无'" @click="handleActionHide"></span></span>
      <span class="r">
        <div class="button" style="font-size:12px;top:-5px;position:relative;" @click="handleActionShow">
          <el-button type="warning" size="small" style="width:60px;height:20px;font-size:12px;padding:2px 2px 2px 2px;border-radius:4px;font-family:PingFangSC-Regular;" >选择动作</el-button>
        </div>
      </span>
    </div>

  </div>

</template>

<script>

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  export default {
    // 组件
    components: {
    },
    // 计算
    computed: {
      checked () {
        for (let i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i] == '0') {
            return false
          }
        }
        return true
      }
    },
    data () {
      return {
        platform: this.$route.query.platform,
        init: '',
        id: '',
        title: '标题名称',
        finality: false,
        looped: false,
        looped_value: 0,
        proto_actioninfo: [],
        next: '',
        mask_visible: true,
        // -------------------------------------------------- [ FLASH ] --------------------------------------------------


        // module的显示状态 默认关闭
        moduleStatus:false,
      }
    },
    methods: {
      handleActionShow () {

        let platform = this.$route.query.platform
        let receiverId = this.moduleStatus?CORE:CORE+ACTION
        let action_core_1_21 = {
                packageId: 0,
                senderId: ACTIONINFO,
                senderName: ACTIONINFO_NAME,
                receiverId: receiverId,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: 21,
                protoBytesType: 'proto.com.proto.s.MUint32',
                protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MUint32(), {
                  setValue: ACTION,
                })
             }

             // 发送消息
            Protocol.sender(platform, action_core_1_21)
            this.moduleStatus = !this.moduleStatus
            //   let actioninfo_action_6_1 = {
            //     packageId: 0,
            //     senderId: ACTIONINFO,
            //     senderName: ACTIONINFO_NAME,
            //     receiverId: ACTION,
            //     receiverName: ACTION_NAME,
            //     timeFlag: new Date().getTime(),
            //     sessionId: 6,
            //     messageId: 1,
            //     protoBytesType: 'proto.com.proto.scene.MSelected',
            //     protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MSelected(), {
            //       setSelected: true,
            //       setId: this.ID,
            //       setType: 'material'
            //     })
            //   }
            //   return
            // // // 发送消息
            // Protocol.sender(platform, actioninfo_action_6_1)
      },
      handleActionHide () {
        let platform = this.$route.query.platform
        let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: this.proto_actioninfo[0],
              setLooped: this.proto_actioninfo[1],
              setRange: this.proto_actioninfo[2],
              setNext: '',
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

          this.next = '无'
      },
      handlePostList (id) {
        // console.log('-------------------> listByIds ActionInfo')
        let param = this.ListByIdCache.check([id])
        if(Object.keys(param.cache).length > 0){
           this.next = param.cache[id].title;
        }
        
        if(param.newId.length) {
            let URL = process.env.HOST + '/pro/api/matter/listByIds'
            let params = 'id=' + param.newId.toString()
            let headers = {
                'token': this.has_token,
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
            this.AJAX.post(URL, headers, params).then((data)=>{
              if(data.code == '0' && Object.keys(data.result).length > 0){
                  this.next = data.result[id].title
                  // 将新的id data添加到缓存中
                  this.ListByIdCache.cacheIdData(data.result)
              }
            }).catch((err)=>{
                this.$message({
                    message: err.msg||err.message,
                    type: 'error'
                })
            })
        }
        // let URL = process.env.HOST + '/pro/api/matter/listByIds'
        // let params = 'id=' + id
        // let headers = {
        //   'token': this.has_token,
        //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        // }

        // this.AJAX.post(URL, headers, params).then((data)=>{
        //   this.next = data.result[id].title
        // }).catch((err)=>{
        //     this.$message({
        //       message: err.msg||err.message,
        //       type: 'error'
        //     })
        // })

      },
      formatTooltip(value) {
        return (value/100).toFixed(2)
      },
      handleChangeSliderOption (value) {

        let platform = this.$route.query.platform

        let duration = parseFloat(value / 100)

        console.log(duration)

        let ff = this.finality ? '1' : '0'

        let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: ff,
              setLooped: '1',
              setRange: duration,
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: value,
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

      },
      handleChangeFinality () {

        let platform = this.$route.query.platform

        if (this.finality) {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: '1',
              setLooped: this.proto_actioninfo[1],
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        } else {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: '0',
              setLooped: this.proto_actioninfo[1],
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        }

      },
      handleChangeLooped (value) {

        let platform = this.$route.query.platform

        if (this.looped) {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: this.proto_actioninfo[0],
              setLooped: '1',
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        } else {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: this.proto_actioninfo[0],
              setLooped: '0',
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        }

      },
      handleChangeOption (value) {

        let platform = this.$route.query.platform

        if (value.length == 1 && value[0] == 1) {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: value[0],
              setLooped: this.proto_actioninfo[1],
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        }

        if (value.length == 1 && value[0] == 0) {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: value[0],
              setLooped: this.proto_actioninfo[1],
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        }

        if (value.length == 2) {

          let actioninfo_scene_7_30 = {
            packageId: 0,
            senderId: ACTIONINFO,
            senderName: ACTIONINFO_NAME,
            receiverId: SCENE,
            receiverName: SCENE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 7,
            messageId: 30,
            protoBytesType: 'proto.com.proto.actioneditortimeline.MActionGlobalInfo',
            protoBytes: Protocol.serializeBinary(new proto.com.proto.actioneditortimeline.MActionGlobalInfo(), {
              setFinality: value[0],
              setLooped: value[1],
              setRange: this.proto_actioninfo[2],
              setNext: this.proto_actioninfo[3],
              setVersion: this.proto_actioninfo[4],
              setSpeed: this.proto_actioninfo[5],
              setEmbeds: this.proto_actioninfo[6],
              setFramerate: this.proto_actioninfo[7]
            })
          }

          // 发送消息
          Protocol.sender(platform, actioninfo_scene_7_30)

        }
      }
    },
    mounted () {

      let platform = this.$route.query.platform
      let _this = this

      // TEXT
      // 模块初始化
      Protocol.onSocketInit(platform, ACTIONINFO_NAME, ACTIONINFO)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform, ACTIONINFO_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, ACTIONINFO_NAME, ACTIONINFO)

      window[ACTIONINFO_NAME].domReady = () => {

        let actioninfo_scene_6_26 = {
          packageId: 0,
          senderId: ACTIONINFO,
          senderName: ACTIONINFO_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 6,
          messageId: 26,
          protoBytesType: '',
          protoBytes: []
        }

        // 发送消息
        Protocol.sender(platform, actioninfo_scene_6_26)

      }

      // 接收消息
      Protocol.receiver(platform, ACTIONINFO_NAME)

      window[ACTIONINFO_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {

        if(sessionId == 6 && messageId == 5) {

          _this.init = 'complete'

          _this.mask_visible = false

          console.log('[' + ACTIONINFO_NAME + '][COMPLETE]')

        }

        if (sessionId == 7 && messageId == 13) {

          let arr = Protocol.deserializeBinary('proto.com.proto.actioneditortimeline.MActionGlobalInfo', protoBytes).array

          _this.proto_actioninfo = arr

          console.log('ACTIONINFO - ', JSON.stringify(arr))

          _this.proto_actioninfo[0] == '1' ? _this.finality = true : _this.finality = false
          _this.proto_actioninfo[1] == '1' ? _this.looped = true : _this.looped = false

          _this.looped_value = _this.proto_actioninfo[5]
          console.log('ACTIONINFO_looped_value - ', _this.looped_value)

          if (arr[3] == undefined) {
            _this.next = '无'
          } else {
            _this.ID =arr[3]
            _this.handlePostList(_this.ID)
          }

        }

        // 锁定模块
        if (sessionId == 1 && messageId == 13){
          _this.mask_visible = true
        }
        // 解除锁定
        if (sessionId == 1 && messageId == 14){
          _this.mask_visible = false
        }

      }

    }
  }
</script>

<style lang="stylus" scoped>
  .actioninfo
    background: #505050//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    .mask
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      width: 280px
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 10
    .title
      margin: 10px
      background: #fff
      border-radius: 3px
    .option
      padding: 15px 10px
      .el-checkbox-group
        display: block
        .item
          padding: 10px 10px 10px 0
          .el-checkbox__label
            font-size: 12px
    .slider
      padding-left: 30px
      padding-right: 40px
      position: relative
      margin-left: 25px
      // .slider_sli
      //   -webkit-transform: scale(0.65)
      //   background:red
      //   position:relative
      //   left:-25px
      //   width:150px
      .text1,
      .text2
        margin-left: -20px
        color: #999
      .text1
        &.active
          color: #000
      .l
        position: absolute
        left: 10px
        top: 25px
        color:#e2e2e2
      .r
        position: absolute
        right: 15px
        top: 25px
        color:#e2e2e2
    .tip
      padding: 50px 10px 10px 10px
      .l
        span
          float: left
          -webkit-transform: scale(0.8)
          margin-left: -10px
          color:#e2e2e2
        .el-icon-circle-cross
          margin-left: -2%
      .r
        float: right
        // button
        //   margin-top: -15px
</style>



// WEBPACK FOOTER //
// ActionInfo.vue?152f3973